import { Button, Flex, Splitter, Select, Space, DatePicker, Table } from 'antd';
import { useState, useEffect } from "react";
import { ProCard } from '@ant-design/pro-components';
import dayjs from 'dayjs';
import { getCostData, getCostFilterOptions, getCostGroupByTags, getCostOptionValues, getCostFilterTagValues, getCostOptions, downloadCost } from '@/apis';
import { CostChart } from './CostChart';
import { CostUsageBreakdown } from './CostUsageBreakdown';
import { DownloadOutlined } from '@ant-design/icons';
import { CostFilterSelect } from './CostSelect';
import { useResourceContext } from '@/layouts/ResourceContext';

export const CostExplorer = () => {
  const { rootState, tenantName } = useResourceContext();
  const { RangePicker } = DatePicker;
  const [sizes, setSizes] = useState(['75%', '25%']);
  const saasGroupbyOpts = [
    { label: "None", value: "None" },
    { label: "Service", value: "Service" },
    { label: "Region", value: "Region" },
    { label: "Instance type", value: "Instance type" },
    { label: "Tag", value: "Tag" },
    { label: "Tenant", value: "Tenant" }
  ];
  const tenantGroupbyOpts = [
    { label: "None", value: "None" },
    { label: "Service", value: "Service" }
  ];
  const [groupbyOpts, setGroupbyOpts] = useState(rootState.tenantMode?tenantGroupbyOpts:saasGroupbyOpts);
  const [granularity, setGranularity] = useState("Monthly");
  const [isLoading, setIsLoading] = useState(false);
  const [costdata, setCostdata] = useState(null);
  const [costParams, setCostParams] = useState({
    startdate: dayjs().add(-6, 'month').startOf('month').format('YYYY-MM-DD'),
    enddate: dayjs().add(-1, 'month').endOf('month').format('YYYY-MM-DD'),
    granularity: "Monthly",
    meta:{Groupby:{Type:"Service"},Filter:rootState.tenantMode?[{Key:"Tag",Name:"vtTenant",Values:[rootState.tenantName],Operation : "Include"}]:[]}
  });


  const fetchGroupby = async () => {
    const response = await getCostOptionValues("groupby");
    let items = []
    response.forEach((item) => {
      items.push({ label: item, value: item });
    });
    setGroupbyOpts(items);
  };
/*
  useEffect(() => { 
    fetchGroupby();
  }, []);
*/
  useEffect(() => {    
    let params = costParams;
    const _getCostData = async ( meta ) => {
      setIsLoading(true);
      const response = await getCostData(meta);
      setCostdata(response);
      setTimeout(() => {
        setIsLoading(false);
      }, 200); 
      
    };
    _getCostData(params);
  }, [costParams]);


  const onDateRangeChange = (dates, dateStrings) => {
    if (dates) {
      console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
      costParams.startdate = dateStrings[0];
      costParams.enddate = dateStrings[1];
      setCostParams({startdate:dateStrings[0],
                     enddate:dateStrings[1],
                     granularity:costParams.granularity,
                     meta:costParams.meta});
    } 
  };
  const [isGroupbyTag, setIsGroupbyTag] = useState(false);
  const [groupbyTagOpts, setGroupbyTagOpts] = useState([]);
  const [groupbyValue, setGroupbyValue] = useState("Service");
  const fetchGroupbyTag = async () => {
    const response = await getCostGroupByTags();
    let items = []
    response.filter((t) => t != 'vtTenant').forEach((item) => {
      items.push({ label: item, value: item });
    });
    setGroupbyTagOpts(items);
  };
  const onGroupbyChange = (value) => {
    setGroupbyValue(value);
    if(value == "Tag"){     
      fetchGroupbyTag();
      setIsGroupbyTag(true);
    } else {
      setIsGroupbyTag(false);
      let param = Object.assign({}, costParams);
      if(value == "Tenant"){
        param.meta.Groupby = {Type:"Tag", Value:"vtTenant"};   
      } else {
        param.meta.Groupby = {Type:value};       
      }
      setCostParams(param);
      
    }
  };

  const onGroupbyTagChange = (value) => {
    setCostParams({startdate:costParams.startdate,
      enddate:costParams.enddate,
      granularity:costParams.granularity,
      meta:{Groupby:{Type:"Tag", Value:value}, Filter:costParams.meta.Filter}});
  };

  const downloadCostData = async () => {
    const response = await downloadCost(costParams);
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'costs.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const fetchFilterOptions = async (optName) => {
      const response = await getCostFilterOptions(optName);
      if(optName == 'Tag'){
         return response.filter(item => item !== 'vtTenant');
      } else {
         return response;
      }
  };

  const onFilterChange = (filterType, values, includeExclude) => {
    let params = Object.assign({}, costParams);
    let filter = params.meta.Filter;
    if(filterType == 'Tag'){
      let hasDeleted = false;
      tagSelects.forEach((item) => {
        let idx = values.indexOf(item);
        if(idx == -1){//removed tag filter
          let fIdx = filter.findIndex((f) => f.Key == 'Tag' && f.Name == item);
          filter.splice(fIdx, 1);
          hasDeleted = true;
        }        
      });
      setTagSelects(values);
      if(hasDeleted) {
        setCostParams(params);
      }
    } else {
     if(filterType == "Service" || filterType == "Region" || filterType == "Instance type" ){
        let idx = filter.findIndex((item) => item.Key == filterType);
        if(idx >= 0){
          if(values && values.length > 0){
            filter[idx].Values = values;
            filter[idx].Operation = includeExclude;
          } else {
            filter.splice(idx, 1);
          }
        } else if(values.length > 0){
          filter.push({Key:filterType, Values:values, Operation:includeExclude});
        }
      } else {
        //filter by tag value
        let idx = filter.findIndex((item) => item.Key == 'Tag' && item.Name == filterType);
        if(idx >= 0){
          if(values && values.length > 0){
            filter[idx].Values = values;
            filter[idx].Operation = includeExclude;
          } else {
            filter.splice(idx, 1);
          }
        } else if(values.length > 0){
          filter.push({Key:'Tag', Name:filterType, Values:values, Operation:includeExclude});
        }
      }
      setCostParams(params);
    }
  };
  const fetchFilterTagOptions = async (tagName) => {
    const response = await getCostFilterTagValues(tagName);
    return response;
  };
  const [tagSelects, setTagSelects] = useState([]);
  return (
    <Splitter
    onResize={setSizes}
    style={{
      height: "100%",
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    }}
  >
    <Splitter.Panel size={sizes[0]} min="70%">
        <ProCard
          split='horizontal'
          bordered
        >
          <ProCard title={<span style={{fontSize:'x-large'}}>Cost and usage graph</span>} >
            <div style={{height: 630, width:'100%'}}><CostChart data={costdata} granularity={granularity} isLoading={isLoading}/></div>
          </ProCard>
          <ProCard>
            <Flex gap="small" align="flex-start" vertical>
              <Flex style={{width: '100%'}} justify='space-between' align='center'>
               <span style={{fontSize:'x-large'}}>Cost and usage breakdown</span>
               <Button icon={<DownloadOutlined />} type="primary" onClick={() => {downloadCostData(); }}>Download as CSV</Button>
              </Flex>
              <CostUsageBreakdown data={costdata} granularity={granularity} isLoading={isLoading}> </CostUsageBreakdown>
            </Flex>
          </ProCard>
        </ProCard>
    </Splitter.Panel>
    <Splitter.Panel size={sizes[1]}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 2,
          gap: 1,
        }}
      >
        <ProCard
          title="Time"
          size="small"
          collapsible
        >
          <Flex gap="middle" vertical>
            <Flex gap="small" vertical>
              <div>
                Date Range
              </div>
              <RangePicker presets={[
                  {
                    label: 'Last 1 Day',
                    value: [dayjs().add(-1, 'd'), dayjs()],
                  },
                  {
                    label: 'Last 7 Days',
                    value: [dayjs().add(-7, 'd'), dayjs()],
                  },
                  {
                    label: 'Month to Date',
                    value: [dayjs().startOf('month'), dayjs()],
                  },
                  {
                    label: 'Current Month',
                    value: [dayjs().startOf('month'), dayjs().endOf('month')],
                    desc: "Current Month"
                  },
                  {
                    label: 'Last 1 Month',
                    value: [dayjs().add(-1, 'month').startOf('month'), dayjs().add(-1, 'month').endOf('month')],
                  },
                  {
                    label: 'Last 3 Month',
                    value: [dayjs().add(-3, 'month').startOf('month'), dayjs().add(-1, 'month').endOf('month')],
                  },
                  {
                    label: 'Last 6 Month',
                    value: [dayjs().add(-6, 'month').startOf('month'), dayjs().add(-1, 'month').endOf('month')],
                  },
                  {
                    label: 'Last 1 Year',
                    value: [dayjs().add(-12, 'month').startOf('month'), dayjs().add(-1, 'month').endOf('month')],
                  },
                  {
                    label: 'Year to Date',
                    value: [dayjs().startOf('year'), dayjs()],
                  }
              ]} onChange={onDateRangeChange} 
              disabledDate={(current) => {
                  return current.isAfter(dayjs()) || current.isBefore(dayjs().add(-12, 'month').startOf('month'));
                }}
              defaultValue={[dayjs().add(-6, 'month').startOf('month'),dayjs().add(-1, 'month').endOf('month')]}/>

            </Flex>
            <Flex gap="small" vertical>
              <div>
                Granularity
              </div>
              <Select
                options={[{ label: "Daily", value: "Daily" }, { label: "Monthly", value: "Monthly" }]}
                onChange={(value) => {
                  setGranularity(value);
                  setCostParams({startdate:costParams.startdate,
                    enddate:costParams.enddate,
                    granularity:value,
                    meta:costParams.meta});
                }}
                defaultValue={"Monthly"}
              />
            </Flex>
          </Flex>
        </ProCard>
        <ProCard
          title="Group by"
          size="small"
          collapsible
        >
          <Flex gap="middle" vertical>
            <Flex gap="small" vertical>
              <div>
                <Flex style={{width: '100%'}} justify='space-between' align='center'> 
                  <span>
                  Dimension
                  </span> 
                  <span>
                    <Button type="link" style={{padding: 0}} onClick={() => {
                      onGroupbyChange("None");
                    }}>Clear</Button>
                  </span>
                </Flex>
              </div>
              <Select
                options={groupbyOpts}
                onChange={onGroupbyChange}
                value={groupbyValue}
              />
            </Flex>
            {isGroupbyTag && <Flex gap="small" vertical style={{paddingLeft: 13}}>
              <Flex gap="small" vertical>
                <div>
                  Tag
                </div>
                <Select
                  options={groupbyTagOpts}
                  onChange={onGroupbyTagChange}
                />
              </Flex>
            </Flex>}
          </Flex>  
        </ProCard>
        <ProCard
          size="small"
          title="Filters"
          collapsible
        >
          {rootState.tenantMode && <Flex gap="middle" vertical>
            <CostFilterSelect label='Instance name' placeholder='Choose instance name' 
               fetchFunc={()=> { return fetchFilterTagOptions('vtInstanceName')}} 
               onChange={(values, includExclude) => onFilterChange('vtInstanceName', values, includExclude)} />
          </Flex>}
          {!rootState.tenantMode && <Flex gap="middle" vertical>
            <CostFilterSelect label='Tenant' placeholder='Choose tenants' 
               fetchFunc={()=> { return fetchFilterTagOptions('vtTenant')}} 
               onChange={(values, includExclude) => onFilterChange('vtTenant', values, includExclude)} />      
            <CostFilterSelect label='Service' placeholder='Choose services' 
               fetchFunc={()=> { return fetchFilterOptions('Service')}} 
               onChange={(values, includExclude) => onFilterChange('Service', values, includExclude)} />
            <CostFilterSelect label='Region' placeholder='Choose regions' 
               fetchFunc={()=> { return fetchFilterOptions('Region')}} 
               onChange={(values, includExclude) => onFilterChange('Region', values, includExclude)} />
            <CostFilterSelect label='Instance type' placeholder='Choose instance types' 
               fetchFunc={()=> { return fetchFilterOptions('Instance type')}} 
               onChange={(values, includExclude) => onFilterChange('Instance type', values, includExclude)} /> 
            <CostFilterSelect label='Tag' placeholder='Choose tags' showAll={false} showIncludeExclude={false}
               fetchFunc={()=> { return fetchFilterOptions('Tag')}} 
               onChange={(values) => onFilterChange('Tag', values)} /> 
            <Flex gap="middle" vertical style={{paddingLeft: 13}}>   
               {tagSelects.map(tag => (
                <CostFilterSelect label={tag} placeholder='Choose tag values' 
                fetchFunc={()=> { return fetchFilterTagOptions(tag)}} 
                onChange={(values, includExclude) => onFilterChange(tag, values, includExclude)} />             
              ))} 
            </Flex>
          </Flex>}
        </ProCard>
      </div>
    </Splitter.Panel>
  </Splitter>
  );
};

